module.exports = __webpack_public_path__ + "static/media/Lustre.7946c626.png";